export const ActivityTypes = {
    MEALS: {
        label: "Meals",
        id: 0,
        registrableByDefault: true,
        isAgendaItem: true,
    },
    ENTERTAINMENT: {
        label: "Entertainment",
        id: 1,
        registrableByDefault: false,
        isAgendaItem: true,
    },
    SECTOR_MEETINGS: {
        label: "Sector Meetings",
        id: 2,
        registrableByDefault: true,
        isAgendaItem: true,
    },
    HOTEL: {
        label: "Hotel",
        id: 3,
        registrableByDefault: false,
        isAgendaItem: true,
    },
    // BILATERAL_MEETINGS: {
    //     label: "Bilateral Meetings",
    //     id: 4,
    //     registrableByDefault: false,
    //     isAgendaItem: true,
    // },
    OTHER: {
        label: "Other (Agenda Item)",
        id: 5,
        registrableByDefault: false,
        isAgendaItem: true,
    },
    THEATRE: {
        label: "Theatre",
        id: 6,
        registrableByDefault: false,
        isAgendaItem: false,
    },
    GALLERY: {
        label: "Gallery",
        id: 7,
        registrableByDefault: false,
        isAgendaItem: false,
    },
    MUSEUM: {
        label: "Museum",
        id: 8,
        registrableByDefault: false,
        isAgendaItem: false,
    },
    RESTAURANT: {
        label: "Restaurant",
        id: 9,
        registrableByDefault: false,
        isAgendaItem: false,
    },
    BARS: {
        label: "Bars",
        id: 10,
        registrableByDefault: false,
        isAgendaItem: false,
    },
    PUBS: {
        label: "Pubs",
        id: 11,
        registrableByDefault: false,
        isAgendaItem: false,
    },
    AREAS: {
        label: "Areas",
        id: 12,
        registrableByDefault: false,
        isAgendaItem: false,
    },
    LEISURE: {
        label: "Leisure",
        id: 13,
        registrableByDefault: false,
        isAgendaItem: false,
    },
    OTHER_ACTIVITIES: {
        label: "Other Activities",
        id: 14,
        registrableByDefault: false,
        isAgendaItem: false,
    }
}

export const ActivityTypesArray = Object.values(ActivityTypes);
